import script from "./QuestionBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionBoard.vue?vue&type=script&setup=true&lang=js"

import "./QuestionBoard.vue?vue&type=style&index=0&id=eca4f3b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eca4f3b8"]])

export default __exports__